import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ProductSearchPagePresentation } from "./ProductSearchPagePresentation";
import React, { useState } from "react";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";
import { FixaSearchActions } from "@coworker/apprestructured/src/shared/wrappers/FixaSearch/FixaSearch";
import { useScannerInputDetection } from "../../hooks/useScannerInputDetection";

interface ProductSearchComponentProps {
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  handleItemCardClick: (item: Item) => void;
  itemCardRenderType: SearchItemCardRenderType;
  shouldHideSPRItems: boolean;
  shouldHideLocalCombinationItems: boolean;
  shouldHideHistory?: boolean;
  shouldHideResults?: boolean;
  searchBarActions?: FixaSearchActions[];
  autoFocus?: boolean;
  onSearchFocus?: () => void;
  onSearchBlur?: () => void;
}

export const ProductSearchComponent = ({
  searchQuery,
  setSearchQuery,
  handleItemCardClick,
  itemCardRenderType,
  shouldHideSPRItems,
  shouldHideLocalCombinationItems,
  shouldHideHistory = false,
  shouldHideResults = false,
  searchBarActions,
  autoFocus = true,
  onSearchFocus,
  onSearchBlur,
}: ProductSearchComponentProps) => {
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isInteractingWithHistory, setIsInteractingWithHistory] =
    useState(false);

  const { handleInputChange } = useScannerInputDetection(
    searchQuery.length,
    (articleNumber) => setSearchQuery(articleNumber)
  );

  const handleSearchQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    handleInputChange(value);
  };

  const handleSearchQueryReset = () => {
    setSearchQuery("");
  };

  const handleSearchBlur = () => {
    if (!isInteractingWithHistory) {
      setIsSearchFocused(false);
      onSearchBlur?.();
    }
  };

  const handleSearchFocus = () => {
    setIsSearchFocused(true);
    onSearchFocus?.();
  };

  return (
    <ProductSearchPagePresentation
      shouldHideHistory={shouldHideHistory}
      shouldHideResults={shouldHideResults}
      itemCardRenderType={itemCardRenderType}
      searchQuery={searchQuery || ""}
      setSearchQuery={setSearchQuery || (() => {})}
      handleItemCardClick={handleItemCardClick}
      shouldHideSPRItems={shouldHideSPRItems}
      shouldHideLocalCombinationItems={shouldHideLocalCombinationItems}
      searchBarActions={searchBarActions}
      autoFocus={autoFocus}
      isSearchFocused={isSearchFocused}
      isInteractingWithHistory={isInteractingWithHistory}
      setIsInteractingWithHistory={setIsInteractingWithHistory}
      handleSearchQueryChange={handleSearchQueryChange}
      handleSearchQueryReset={handleSearchQueryReset}
      handleSearchBlur={handleSearchBlur}
      handleSearchFocus={handleSearchFocus}
    />
  );
};
